var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.handleKbSearchEntered.apply(null, arguments)}}},[_c('InputSearch',{attrs:{"placeholder":"Search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }